import { AppsComponent } from './apps/apps.component';
import { AvailabilitiesComponent } from './availabilities/availabilities.component';
import { BookingsComponent } from './bookings/bookings.component';
import { ClientsComponent } from './clients/clients.component';
import { CommunicationsComponent } from './communications/communications.component';
import { IdentityProviderComponent } from './identity-provider/identity-provider.component';
import { OperatorsComponent } from './operators/operators.component';
import { ServicesComponent } from './services/services.component';
import { SetupComponent } from './setup/setup.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { TownsComponent } from './towns/towns.component';
import { TripsComponent } from './trips/trips.component';
import { UsersComponent } from './users/users.component';
import { VehiclesComponent } from './vehicles/vehicles.component';

export {
  AppsComponent,
  AvailabilitiesComponent,
  BookingsComponent,
  ClientsComponent,
  CommunicationsComponent,
  IdentityProviderComponent,
  OperatorsComponent,
  ServicesComponent,
  SetupComponent,
  SignInComponent,
  TownsComponent,
  TripsComponent,
  UsersComponent,
  VehiclesComponent,
};

export const pages = [
  AppsComponent,
  AvailabilitiesComponent,
  BookingsComponent,
  ClientsComponent,
  CommunicationsComponent,
  IdentityProviderComponent,
  OperatorsComponent,
  ServicesComponent,
  SetupComponent,
  SignInComponent,
  TownsComponent,
  TripsComponent,
  UsersComponent,
  VehiclesComponent,
]

